import React from 'react';

interface RequiredLabelProps {
  label: string;
  mandatory?: boolean;
}

// const labelStyles = {
//   fontFamily: 'Helvetica Neue',
//   fontSize: '14px',
//   fontWeight: 700,
//   lineHeight: '19.54px',
//   color: '#1E1E1E',
// };

const inputStyles = {
  font: 'normal normal 600 12px/16px Segoe UI',
  color: '#000000'
};

const RequiredLabel: React.FC<RequiredLabelProps> = ({ label, mandatory = false }) => {
  return (
    <label style={inputStyles}>
      {label} {mandatory && <span style={{ color: 'red' }}>*</span>}
    </label>
  );
};

export default RequiredLabel;